/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { ProductionMaterialType } from "./ProductionMaterialType";
import { SizeLabel } from "./SizeLabel";
import { ProductType } from "./ProductType";

export class DrawableObjectDto {
    id: string;
    locationUrl: string;
    imageUrl: string;
    name: string;
    height: number;
    width: number;
    depth: number;
    productionMaterialType: ProductionMaterialType;
    sizeLabel: SizeLabel | null;
    productType: ProductType;
    specification: Object;
    color: string;
}
